import './style.scss';
interface Props {
	className?: string;
}

export const DisciplineSkeleton: React.FC<Props> = (props) => (
	<svg viewBox="0 0 296 440" xmlns="http://www.w3.org/2000/svg" className="discipline__skeleton" {...props}>
		<rect width="296" height="440" rx="8" />
		<rect x="12" y="20" width="86" height="15" rx="7.5" fill="#E6E6E6" />
		<circle cx="22" cy="62" r="8" fill="#E6E6E6" />
		<circle cx="46" cy="62" r="8" fill="#E6E6E6" />
		<rect x="62" y="56" width="86" height="12" rx="6" fill="#E6E6E6" />
		<rect x="274" y="56" width="10" height="12" rx="5" fill="#E6E6E6" />
		<circle cx="22" cy="94" r="8" fill="#E6E6E6" />
		<circle cx="46" cy="94" r="8" fill="#E6E6E6" />
		<rect x="62" y="88" width="56" height="12" rx="6" fill="#E6E6E6" />
		<rect x="261" y="88" width="23" height="12" rx="6" fill="#E6E6E6" />
		<circle cx="22" cy="126" r="8" fill="#E6E6E6" />
		<circle cx="46" cy="126" r="8" fill="#E6E6E6" />
		<rect x="62" y="120" width="111" height="12" rx="6" fill="#E6E6E6" />
		<rect x="268" y="120" width="16" height="12" rx="6" fill="#E6E6E6" />
		<circle cx="22" cy="158" r="8" fill="#E6E6E6" />
		<circle cx="46" cy="158" r="8" fill="#E6E6E6" />
		<rect x="62" y="152" width="93" height="12" rx="6" fill="#E6E6E6" />
		<rect x="262" y="152" width="22" height="12" rx="6" fill="#E6E6E6" />
		<circle cx="22" cy="190" r="8" fill="#E6E6E6" />
		<circle cx="46" cy="190" r="8" fill="#E6E6E6" />
		<rect x="62" y="184" width="78" height="12" rx="6" fill="#E6E6E6" />
		<rect x="268" y="184" width="16" height="12" rx="6" fill="#E6E6E6" />
		<circle cx="22" cy="222" r="8" fill="#E6E6E6" />
		<circle cx="46" cy="222" r="8" fill="#E6E6E6" />
		<rect x="62" y="216" width="81" height="12" rx="6" fill="#E6E6E6" />
		<rect x="263" y="216" width="21" height="12" rx="6" fill="#E6E6E6" />
		<circle cx="22" cy="254" r="8" fill="#E6E6E6" />
		<circle cx="46" cy="254" r="8" fill="#E6E6E6" />
		<rect x="62" y="248" width="46" height="12" rx="6" fill="#E6E6E6" />
		<rect x="264" y="248" width="20" height="12" rx="6" fill="#E6E6E6" />
		<circle cx="22" cy="286" r="8" fill="#E6E6E6" />
		<circle cx="46" cy="286" r="8" fill="#E6E6E6" />
		<rect x="62" y="280" width="51" height="12" rx="6" fill="#E6E6E6" />
		<rect x="274" y="280" width="10" height="12" rx="5" fill="#E6E6E6" />
		<circle cx="22" cy="318" r="8" fill="#E6E6E6" />
		<circle cx="46" cy="318" r="8" fill="#E6E6E6" />
		<rect x="62" y="312" width="34" height="12" rx="6" fill="#E6E6E6" />
		<rect x="269" y="312" width="15" height="12" rx="6" fill="#E6E6E6" />
		<circle cx="22" cy="350" r="8" fill="#E6E6E6" />
		<circle cx="46" cy="350" r="8" fill="#E6E6E6" />
		<rect x="62" y="344" width="36" height="12" rx="6" fill="#E6E6E6" />
		<rect x="274" y="344" width="10" height="12" rx="5" fill="#E6E6E6" />
		<circle cx="22" cy="382" r="8" fill="#E6E6E6" />
		<circle cx="46" cy="382" r="8" fill="#E6E6E6" />
		<rect x="62" y="376" width="77" height="12" rx="6" fill="#E6E6E6" />
		<rect x="274" y="376" width="10" height="12" rx="5" fill="#E6E6E6" />
		<circle cx="22" cy="414" r="8" fill="#E6E6E6" />
		<circle cx="46" cy="414" r="8" fill="#E6E6E6" />
		<rect x="62" y="408" width="37" height="12" rx="6" fill="#E6E6E6" />
		<rect x="266" y="408" width="18" height="12" rx="6" fill="#E6E6E6" />
	</svg>
);
